import { classNames } from 'libs/react';
import { Icon } from './Icon';
import { React } from 'libs/react';
import './Sidebar.scss';
/**
 * @component Sidebar
 * @since 1.0.0
 */
export function Sidebar(props) {
    const { style } = Object.assign({ style: 'normal' }, props);
    const className = classNames('sidebar', 'sidebar--' + style, 'dark-mode', props.className);
    return (React.createElement("section", { className: className },
        React.createElement("div", { className: "sidebar-body" }, props.children),
        React.createElement("div", { className: "sidebar-grab" },
            React.createElement(Icon, { className: "sidebar-grab-icon", value: "sidebar-flip" }))));
}
